import { getSystemConfig } from '@/api/system';
import types from '../types';

const state = {
  system: {},
};

const mutations = {
  [types.SET_SYSTEM](state, roles) {
    state.system = roles;
  }
};

const actions = {
  getSystemConfig({ commit }) {
    this.tableLoading = true;
    return getSystemConfig()
      .then(res => {
        const roles = res.data.data || [];
        document.title = roles.name || '信服魔方';
        commit(types.SET_SYSTEM, roles);
        this.tableLoading = false;
      })
      .catch(error => {
        this.tableLoading = false;
        Promise.reject(error);
      });
  }
};

export default {
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/sys.js